/**
 * LinkedIn search utility functions
 */

import { safeWindowOpen } from "../components/utils/utils";

export interface LinkedInSearchParams {
  firstName?: string;
  lastName?: string;
  company?: string;
}

export type LinkedInSearchType = "all" | "people";

/**
 * Builds a LinkedIn search URL with the provided parameters
 * @param params - Object containing firstName, lastName, and company
 * @param searchType - Type of LinkedIn search ('all' or 'people'), defaults to 'all'
 * @returns The formatted LinkedIn search URL
 */
export const buildLinkedInSearchUrl = (
  params: LinkedInSearchParams,
  searchType: LinkedInSearchType = "all"
): string => {
  const { firstName = "", lastName = "", company = "" } = params;

  let keywords = "";
  if (firstName || lastName) {
    keywords = `${encodeURIComponent(firstName)} ${encodeURIComponent(
      lastName
    )}`.trim();
  }

  if (company) {
    keywords = [encodeURIComponent(company), keywords]
      .filter((item) => item)
      .join(":")
      .trim();
  }

  return `https://www.linkedin.com/search/results/${searchType}/?keywords=${keywords}`;
};

/**
 * Opens a LinkedIn search in a new tab using safeWindowOpen
 * @param params - Object containing firstName, lastName, and company
 * @param searchType - Type of LinkedIn search ('all' or 'people'), defaults to 'all'
 */
export const openLinkedInSearch = (
  params: LinkedInSearchParams,
  searchType: LinkedInSearchType = "all"
): void => {
  const url = buildLinkedInSearchUrl(params, searchType);
  safeWindowOpen(url);
};
